import { Box } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { AmountWithDate } from "Components/Shared/Transactions/AmountWithDate";
import { TransactionIcon } from "Components/Shared/Transactions/TransactionIcon";
import { TransactionInfo } from "Components/Shared/Transactions/TransactionInfo";
import { isTransactionUnsuccessful } from "Components/Shared/Transactions/transactionsUtils";
import type { TransactionItem as TransactionItemType } from "Infrastructure/Api/Api";
import { Link } from "Navigation/Link";
import type { ViewerTransactionDirection } from "Utils/TransactionUtils";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  item: TransactionItemType;
  direction: ViewerTransactionDirection;
  isBottomBorderHidden?: boolean;
};

export const MerchantTransactionItem = ({
  direction,
  isBottomBorderHidden,
  item: { publicID, status, dateCreated, amount },
}: Props) => {
  const isUnsuccessful = isTransactionUnsuccessful(status);
  const bottomBorder = isBottomBorderHidden
    ? undefined
    : `1px solid ${Colors.MediumGrey}`;

  return (
    <Link
      to={`${appUrl("transaction-detail")}/${publicID}`}
      style={{ all: "unset" }} //to remove underlines
    >
      <Box
        component="span"
        display="flex"
        width="100%"
        mt={2.5}
        pb={1.5}
        sx={{ cursor: "pointer" }}
        borderBottom={bottomBorder}
        justifyContent="space-between"
      >
        <Box component="span" display="flex" alignItems="center" gap={4}>
          <TransactionIcon status={status} />
          <TransactionInfo
            direction={direction}
            publicID={publicID}
            isUnsuccessful={isUnsuccessful}
          />
        </Box>
        <AmountWithDate
          dateCreated={dateCreated}
          amount={amount}
          direction={direction}
        />
      </Box>
    </Link>
  );
};
